export default class Auth {
  constructor() {
    this.emailToRecoverPasswordFor = null;
  }
}
